export const fileSizeConverter = (size) => {
  const k = 1024;
  const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb"];
  const i = Math.floor(Math.log(size) / Math.log(k));
  const fileSize = (size / k ** i).toFixed(2) + " " + sizes[i];
  return fileSize;
};
